import React, { useState } from 'react';

const PISTAS = [1, 2, 3, 4];

// Alta/baja de tramos reservados de una jornada real. reemplazarDisponibilidad
// sustituye TODOS los tramos de golpe (borra e inserta, sin id de tramo que
// editar uno a uno desde el front — ver asignacionPistaService.js), así que
// este panel trabaja sobre un borrador local y solo llama a la API al
// guardar.
const DisponibilidadPanel = ({ disponibilidad, onGuardar, guardando }) => {
  const [borrador, setBorrador] = useState(() => disponibilidad.map((t) => ({ ...t })));
  const [nuevoPistas, setNuevoPistas] = useState([]);
  const [nuevaHoraInicio, setNuevaHoraInicio] = useState('10:00');
  const [nuevaHoraFin, setNuevaHoraFin] = useState('10:30');
  const [huboCambios, setHuboCambios] = useState(false);

  const togglePista = (pista) => {
    setNuevoPistas((prev) => (prev.includes(pista) ? prev.filter((p) => p !== pista) : [...prev, pista].sort()));
  };

  const anadirTramo = () => {
    if (!nuevoPistas.length || nuevaHoraFin <= nuevaHoraInicio) return;
    const nuevos = nuevoPistas.map((pista) => ({ pista, hora_inicio: nuevaHoraInicio, hora_fin: nuevaHoraFin }));
    setBorrador((prev) => [...prev, ...nuevos]);
    setNuevoPistas([]);
    setHuboCambios(true);
  };

  const quitarTramo = (indice) => {
    setBorrador((prev) => prev.filter((_, i) => i !== indice));
    setHuboCambios(true);
  };

  const guardar = () => {
    onGuardar(borrador.map((t) => ({ pista: t.pista, horaInicio: t.hora_inicio, horaFin: t.hora_fin })));
    setHuboCambios(false);
  };

  return (
    <div className="cp-disponibilidad">
      <h4>Pistas reservadas de esta jornada</h4>
      {!borrador.length && <p className="cp-pool-vacio">Todavía no hay ningún tramo de pista reservado.</p>}
      {!!borrador.length && (
        <ul className="cp-disponibilidad-lista">
          {borrador.map((t, i) => (
            <li key={`${t.pista}-${t.hora_inicio}-${i}`}>
              Pista {t.pista}: {t.hora_inicio}–{t.hora_fin}
              <button type="button" className="cp-disponibilidad-quitar" onClick={() => quitarTramo(i)} aria-label={`Quitar tramo pista ${t.pista}`}>✕</button>
            </li>
          ))}
        </ul>
      )}

      <div className="cp-disponibilidad-nuevo">
        <span>Pistas</span>
        {PISTAS.map((pista) => (
          <label key={pista} className="cp-disponibilidad-checkbox">
            <input type="checkbox" checked={nuevoPistas.includes(pista)} onChange={() => togglePista(pista)} />
            {pista}
          </label>
        ))}
        <label>
          De
          <input type="time" value={nuevaHoraInicio} onChange={(e) => setNuevaHoraInicio(e.target.value)} step="1800" />
        </label>
        <label>
          A
          <input type="time" value={nuevaHoraFin} onChange={(e) => setNuevaHoraFin(e.target.value)} step="1800" />
        </label>
        <button type="button" className="btn btn-secondary btn-sm" onClick={anadirTramo}>+ Añadir tramo</button>
      </div>

      <button type="button" className="btn btn-primary" onClick={guardar} disabled={!huboCambios || guardando}>
        {guardando ? 'Guardando…' : 'Guardar disponibilidad'}
      </button>
    </div>
  );
};

export default DisponibilidadPanel;
